var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReaction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1656387536743,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 9498,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M804.223 403.955a133.977 133.977 0 0 0-45.752 8.016c20.177-109.526-27.374-201.793-100.338-246.591-69.31-42.562-170.685-42.917-244.138 46.57-49.133-59.467-116.043-85.588-184.916-70.565-84.033 18.377-148.98 93.303-161.631 186.498-10.09 74.49 2.126 267.285 333.733 447.975a26.752 26.752 0 0 0 25.739 0c24.484-13.306 47.932-27.156 69.963-41.252 42.263 54.068 105.081 104.047 187.37 148.898 3.982 2.182 8.453 3.273 12.87 3.273s8.835-1.091 12.87-3.273c97.557-53.168 167.793-113.562 208.801-179.408 45.533-73.126 43.952-134.61 34.627-173.329-17.722-73.48-80.434-126.812-149.198-126.812m-107.1 422.373C476.16 701.15 485.759 579.3 494.156 544.4c11.67-48.56 52.024-83.842 95.812-83.842 32.392 0 62.166 19.686 83.815 55.432 5.016 8.289 13.852 13.36 23.34 13.36s18.323-5.072 23.34-13.36c21.595-35.746 51.368-55.432 83.761-55.432 43.844 0 84.142 35.283 95.812 83.842 8.452 34.9 17.995 156.779-202.913 281.928",
    fill: "",
    "p-id": 9499
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaction);
export default __webpack_public_path__ + "static/media/reaction.0bb7d9a3.svg";
export { ForwardRef as ReactComponent };